import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AUTH } from "@/constants/testIds";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, a reset link was sent.");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your account email and we'll send you a reset link."
      footer={<Link to="/login" className="text-primary hover:underline">← Back to sign in</Link>}
    >
      {sent ? (
        <div className="rounded-xl border border-primary/25 bg-primary/10 p-4 text-sm">
          Check your inbox — if <b>{email}</b> matches an account, we sent instructions.
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <label className="text-xs font-medium text-muted-foreground">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid={AUTH.emailInput}
              className="w-full rounded-xl bg-muted/40 border border-border px-4 py-3 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"
            />
          </div>
          {error && <div data-testid={AUTH.error} className="text-sm text-red-500">{error}</div>}
          <button type="submit" disabled={busy} data-testid={AUTH.submit} className="btn-primary w-full py-3 text-sm">
            {busy ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
